export const BROADCAST_CHANNEL = 'o-auth';

export function getChannel(state) {
    return `${BROADCAST_CHANNEL}-${state}`;
}
